






























































import Component from 'vue-class-component';
import { Prop, Vue, Watch } from 'vue-property-decorator';
import { cloneDeep } from '@/common/helpers';

@Component({
  name: 'DataSourceList',
})
export default class DataSourceList extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  list!: Array<Orders.AnimalDataSource>;

  @Watch('list')
  refreshInnerList(newList: Array<Orders.AnimalDataSource>) {
    this.setList(newList);
  }

  innerList: Array<Orders.AnimalDataSource> = [];

  editMode: boolean = false;

  setEditMode() {
    this.editMode = true;
  }

  reset() {
    this.setList(this.list);
    this.editMode = false;
  }

  save() {
    const diff = {};
    this.list.forEach((source, index) => {
      if (source.numberIndividuals !== this.innerList[index].numberIndividuals) {
        diff[source.id] = this.innerList[index].numberIndividuals;
      }
    });
    const done = () => {
      this.editMode = false;
    };
    this.$emit('save', diff, done);
  }

  mounted() {
    this.setList(this.list);
  }

  private setList(list: Array<Orders.AnimalDataSource>) {
    this.innerList = cloneDeep(list);
  }
}
